var map = {
	"./FOREX@2x.png": "d965",
	"./FUND@2x.png": "a260",
	"./FUTURES@2x.png": "d1ee",
	"./PM@2x.png": "88f1",
	"./STOCK@2x.png": "d48e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cdc8";